import { observer } from 'mobx-react-lite'
import { type JobListViewModel } from '@/features/jobs/details/components/JobList/JobListViewModel'
import { JobSidebarItemContainer } from '@/features/jobs/details/components/JobSidebarItem/JobSidebarItemContainer'
import { JobSidebarItemSkeleton } from '@/features/jobs/details/components/JobSidebarItem'
import { JobSidebarHeaderContainer } from '@/features/jobs/details/components/JobSidebarHeader/JobSidebarHeaderContainer'
import { SkeletonList } from '@/components/Skeleton'
import { SkeletonListInfiniteScrollTrigger } from '@/components/SkeletonListInfiniteScrollTrigger'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import { ContentError } from '@/components/ContentError'
import { ScrollView } from '@/components/ScrollView'
import { JobListEmptyContainer } from '@/features/jobs/details/components/JobList/JobListEmpty/JobListEmptyContainer'

export interface JobSidebarContainerProps {
  vm: JobListViewModel
}

export const JobSidebarContainer = observer(function JobSidebarContainer({
  vm,
}: JobSidebarContainerProps) {
  return (
    <Sandwich stretch>
      <SandwichBun>
        <JobSidebarHeaderContainer vm={vm} />
      </SandwichBun>
      <SandwichContent>
        {vm.fetch.match({
          pending: () => (
            <ScrollView>
              <SkeletonList count={10}>
                <JobSidebarItemSkeleton />
              </SkeletonList>
            </ScrollView>
          ),
          rejected: (err) => <ContentError error={err} />,
          resolved: () => (
            <ScrollView>
              {vm.showEmptyState && <JobListEmptyContainer vm={vm} />}
              {vm.jobs.map((jobItem) => (
                <JobSidebarItemContainer vm={jobItem} key={jobItem.job.id} />
              ))}
              <SkeletonListInfiniteScrollTrigger
                scroller={vm.searcher.scroller}
                maxSkeletons={10}
              >
                <JobSidebarItemSkeleton />
              </SkeletonListInfiniteScrollTrigger>
            </ScrollView>
          ),
        })}
      </SandwichContent>
    </Sandwich>
  )
})
